import React from 'react';

import { withStyles } from '@mui/styles';

import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';

import Loader from '../../common/Loader';
import CodeEditor from '../../common/CodeEditor';
import CommonStyles from '../../common/CommonStyles';
import ComponentWrapper from '../../common/ComponentWrapper';
import FullScreenDialog from '../../common/FullScreenDialog';
import TrplSelect from '../../common/TrplControls/TrplSelect';
import TrplCheckbox from '../../common/TrplControls/TrplCheckbox';
import TargetAudienceFormula from '../../common/TargetAudienceFormula';

import FlowPageStyles from './FlowPageStyles.js';

import Stimul from './components/Stimul';

import { channels } from '../../constants';

import StimulView from '../StimulView/StimulView';

import { getUrlParameter, setUrlParameter } from '../../utils';
import ActionConfirmation from '../../common/ActionConfirmation';

const styles = { ...CommonStyles, ...FlowPageStyles };

class FlowPage extends ComponentWrapper {
  state = {
    flows: [],
    flow: {},
    loaded: false,
    btnsTypes: [],
    categories: [],
    stimulsTypes: [],
    editNewFlow: false,
    addNewStimul: false,
    isDeleteModalOpened: false,
    stimulView: {
      flow: {
        stimuls: [],
      },
      isOpened: false,
    },
    codeEditor: {
      field: '',
      isOpened: false,
    },
    targetAudienceModal: {
      isOpened: false,
      flowIndex: 0,
      formula: {
        cons: [],
        ops: [],
      },
    },
    categoryValues: [],
    isDeleted: false,
  };

  componentDidMount() {
    document.title="Edit flow | Milkyweb";

    this.getFlows();
  }

  getFlows = () => {
    this.get({
      url: '/get_jel?type=["flow"]&meta_query=["setup_contacts_tbox", "stimuls_types", "btns_types"]',
      cb: (res) => {
        const t_box = res._meta_query.setup_contacts_tbox;

        const subsInterface = res._meta_query.setup_contacts_tbox.interface_id || [];

        let categories = Object.keys(t_box.nodes).map(concept => res._meta_query.setup_contacts_tbox.nodes[concept]);

        let flows = res.flow || [];
        if (!categories) categories = [];

        const flowIdFromUrl = getUrlParameter('id');

        const flow = flowIdFromUrl
          ? flows.find((flow) => flow.id === +flowIdFromUrl)
          : {
              title: 'New flow',
              category: 0,
              stimuls: [],
              isNew: true,
            };

        flow.expanded = false;
        if (!flow.channels) flow.channels = [];

        flow.stimuls.forEach((stimul) => {
          if (!stimul.btn_type) stimul.btn_type = '';
          if (!stimul.btn_title) stimul.btn_title = '';
          if (!stimul.btn_evoked_stimul) stimul.btn_evoked_stimul = '';
          if (!stimul.btn_fallback) stimul.btn_fallback = '';

          const category = categories.find(category => category.id === flow.category);

          flow.pidsValue = category ? this.getRsts(category) : [];

          if (!stimul.pids) stimul.pids = [];
        });

        const pidsData = {};

        if (categories && categories.length) {
          categories.forEach(category => {
            if (category.box.r) {
              Object.keys(category.box.r).forEach(rstConcept => {
                const rsts = category.box.r[rstConcept];
                rsts.forEach(rst => pidsData[rst.id] = rst.title)
              });
            }
          });
        };

        const categoryValues = [];

        categories.forEach(category => 
          +category.id === +subsInterface ? 
          categoryValues.unshift({ value: category.id, title: `All (${category.title})` }) : 
          categoryValues.push({ title: category.title, value: category.id })
        );
        categoryValues.unshift({ title: 'None', value: 0 });

        const stimulsTypes = res._meta_query.stimuls_types || [];
        const btnsTypes = res._meta_query.btns_types || [];

        this.setState({
          flow,
          pidsData,
          btnsTypes,
          categories,
          categoryValues,
          subsInterface,
          stimulsTypes,
          loaded: true,
        });
      },
    });
  };

  onInputChange = (key, e) => {
    this.setState({ [key]: e.target.value });
  };

  getRsts = (category) => {
    const pidsValues = [];
    if (category && category.box.r && Object.keys(category.box.r).length) {
      Object.keys(category.box.r).forEach(rstConcept => {
        category.box.r[rstConcept].forEach(rst => pidsValues.push(rst))
      })
    };
    return pidsValues;
  };

  onFlowFieldChange = (key, value) => {
    const { flow } = this.state;

    flow[key] = value;

    this.setState({ flow });
  };

  onAddNewStimulClick = () => {
    const { flow, categories } = this.state;

    const stimul = {
      pids: [],
      text: '',
      type: '',
      channels: [],
      func_receive: '',
      func_send: '',
      btn_fallback: '',
      btn_title: '',
      btn_evoked_stimul: '',
      btn_type: '',
    };

    const category = categories.find((category) => category.id === flow.category);

    flow.pidsValue = category ? this.getRsts(category) : [];
    flow.stimuls.push(stimul);

    this.setState({ flow });
  };

  onStimulBtnInputChange = (stimulIndex, key, value) => {
    const { flow } = this.state;

    flow.stimuls[stimulIndex][key] = value;

    this.setState({ flow });
  };

  onEditStimulBtnInputChange = (stimulIndex, btnIndex, key, value) => {
    const { flow } = this.state;

    flow.stimuls[stimulIndex].buttons[btnIndex][key] = value;

    this.setState({ flow });
  };

  onStimulFieldChange = (stimulIndex, key, value) => {
    const { flow } = this.state;

    flow.stimuls[stimulIndex][key] = value;

    this.setState({ flow });
  };

  onStimulCodeFieldClick = (stimulIndex, field, btnIndex) => {
    const { flow } = this.state;

    const codeEditor = {
      field,
      stimulIndex,
      isOpened: true,
    };

    if (btnIndex !== undefined) codeEditor.btnIndex = btnIndex;

    const value =
      btnIndex !== undefined
        ? flow.stimuls[codeEditor.stimulIndex].buttons[codeEditor.btnIndex][codeEditor.field]
        : flow.stimuls[codeEditor.stimulIndex][codeEditor.field];

    codeEditor.value = value;

    this.setState({
      codeEditor,
    });
  };

  onStimulBtnAdd = (stimulIndex) => {
    const { flow } = this.state;

    const stimul = flow.stimuls[stimulIndex];

    if (!flow.stimuls[stimulIndex].buttons) {
      flow.stimuls[stimulIndex].buttons = [];
    }

    flow.stimuls[stimulIndex].buttons.push({
      type: stimul.btn_type,
      title: stimul.btn_title,
      evoked_stimul: stimul.btn_evoked_stimul,
      fallback: stimul.btn_fallback,
    });

    flow.stimuls[stimulIndex].btn_title = '';
    flow.stimuls[stimulIndex].btn_type = '';
    flow.stimuls[stimulIndex].btn_evoked_stimul = '';
    flow.stimuls[stimulIndex].btn_fallback = '';

    this.setState({ flow });
  };

  onStimulBtnRemove = (stimulIndex, btnIndex) => {
    const { flow } = this.state;

    flow.stimuls[stimulIndex].buttons.splice(btnIndex, 1);

    this.setState({ flow });
  };

  onDeleteStimulClick = (stimulIndex) => {
    const { flow } = this.state;

    flow.stimuls.splice(stimulIndex, 1);

    this.setState({ flow });
  };

  onStimulModalPidsChange = (stimulIndex, value) => {
    const { flow } = this.state;

    flow.stimuls[stimulIndex].pids = value;

    this.setState({ flow });
  };

  onFlowChannelsChange = (value) => {
    const { flow } = this.state;

    if (value && value.includes('none')) {
      flow.channels = [];
    } else {
      flow.channels = value;
    }

    this.setState({ flow });
  };

  onStimulTypeChange = (stimulIndex, value) => {
    const { flow } = this.state;

    flow.stimuls[stimulIndex].type = value;

    this.setState({ flow });
  };

  onFlowSaveClick = (flowObj) => {
    const { categories } = this.state;
    delete flowObj.isNew;
    delete flowObj.expanded;

    flowObj.stimuls.forEach((stimul) => {
      delete stimul.btn_title;
      delete stimul.btn_type;
      delete stimul.btn_evoked_stimul;
      delete stimul.btn_fallback;
    });

    if (flowObj.formula) {
      delete flowObj.formula.action;
      delete flowObj.formula.concept;
    }

    this.postWithData({
      url: '/rest/upd_jel?type=flow',
      data: flowObj,
      cb: (res) => {
        const { flow } = res;

        const category = categories.find((category) => category.id === flow.category);

        flow.pidsValue = category ? this.getRsts(category) : [];
        flow.expanded = true;

        const flowId = getUrlParameter('id');

        if (!flowId) setUrlParameter('id', flow.id);

        this.setState({ flow });
      },
    });
  };

  onDeleteFlowClick = () => {
    const { flow } = this.state;

    this.get({ url: `/del_jel?id=${flow.id}` });

    this.setState({ flow, isDeleted: true }, () => {
      setTimeout(() => {
        document.location.replace('/flows');
      }, 1000);
    });

    this.closeDeleteModal();
  };

  openDeleteModal = () => {
    this.setState({
      isDeleteModalOpened: true,
    });
  };

  closeDeleteModal = () => {
    this.setState({ isDeleteModalOpened: false });
  };

  onFlowCategoryChange = (value) => {
    const { flow, categories } = this.state;

    flow.category = value;

    const category = categories.find((category) => category.id === value);

    flow.pidsValue = category ? this.getRsts(category) : [];

    this.setState({ flow });
  };

  onStimulViewModalClose = () => {
    const { stimulView } = this.state;

    stimulView.isOpened = false;
    stimulView.flow = {};

    this.setState({ stimulView });
  };

  onSaveStimulPositionsClick = (flow, index) => {
    this.onFlowSaveClick(flow, index);
  };

  onTargetAudienceSaveClick = (formula) => {
    const { flow } = this.state;

    if (!formula.cons.length && !formula.ops.length) {
      delete flow.formula;
    } else {
      flow.formula = formula;
    }

    this.setState({ flow });

    this.toggleTargetAudienceModal(false);
  };

  toggleTargetAudienceModal = (isOpened) => {
    const { flow, targetAudienceModal } = this.state;

    const plainFormula = {
      cons: [],
      ops: [],
    };

    const formula = flow.formula || plainFormula;

    if (isOpened) {
      targetAudienceModal.isOpened = true;
      targetAudienceModal.formula = formula;
    } else {
      targetAudienceModal.isOpened = false;
      targetAudienceModal.formula = plainFormula;
    }

    this.setState({ targetAudienceModal });
  };

  render() {
    const { classes } = this.props;

    const {
      flow,
      loaded,
      pidsData,
      isDeleted,
      btnsTypes,
      categories,
      stimulView,
      codeEditor,
      stimulsTypes,
      subsInterface,
      categoryValues,
      isDeleteModalOpened,
      targetAudienceModal,
    } = this.state;

    const selectClassNames = {
      select: classes.trplSelect,
      icon: classes.trplSelectIcon,
      root: classes.trplSelectContainer,
    };

    const menuProps = {
      classes: {
        paper: classes.trplSelectMenu,
      },
    };

    const itemStyles = {
      minHeight: '24px',
      lineHeight: 'normal',
      fontSize: '12px',
      padding: '0 16px',
    };

    return (
      <div className={classes.container}>
        <ActionConfirmation
          modalData={{
            open: isDeleteModalOpened,
            contentText: "Delete this Flow?",
            contentBoldText: "",
          }}
          acceptHandler={this.onDeleteFlowClick}
          onClose={this.closeDeleteModal}
        />

        <FullScreenDialog title="Stimul view" isOpen={stimulView.isOpened} onClose={this.onStimulViewModalClose}>
          <StimulView
            flow={stimulView.flow}
            flowIndex={stimulView.flowIndex}
            pidsData={pidsData}
            onSaveStimulPositionsClick={this.onSaveStimulPositionsClick}
          />
        </FullScreenDialog>

        <FullScreenDialog
          title="Edit code"
          isOpen={codeEditor.isOpened}
          onClose={() => {
            this.setState({
              codeEditor: {
                field: '',
                isOpened: false,
              },
            });
          }}
        >
          {codeEditor.isOpened ? (
            <CodeEditor
              mode="javascript"
              value={codeEditor.value}
              height={'calc(100vh - 146px)'}
              onSaveBtnClick={(value) => {
                const { flow, codeEditor } = this.state;

                if (codeEditor.btnIndex !== undefined) {
                  flow.stimuls[codeEditor.stimulIndex].buttons[codeEditor.btnIndex][codeEditor.field] = value;
                } else {
                  flow.stimuls[codeEditor.stimulIndex][codeEditor.field] = value;
                }

                this.setState({
                  flow,
                  codeEditor: {
                    field: '',
                    isOpened: false,
                  },
                });
              }}
            />
          ) : null}
        </FullScreenDialog>

        {categories.length && subsInterface &&
          <TargetAudienceFormula
            subs={categories}
            subsInterface={subsInterface}
            formula={targetAudienceModal.formula || []}
            isOpen={targetAudienceModal.isOpened}
            onClose={() => this.toggleTargetAudienceModal(false, targetAudienceModal.flowIndex)}
            onSaveClick={this.onTargetAudienceSaveClick}
          />
        }

        {!loaded ? (
          <div className={classes.loaderContainer}>
            <Loader />
          </div>
        ) : isDeleted ? (
          <h2>Flow is deleted</h2>
        ) : (
          <div>
            <div className={`${classes.alignEnd} ${classes.p10}`} style={{ backgroundColor: '#fff' }}>
              <TextField
                label="Title"
                disableunderline
                value={flow.title}
                className={`${classes.flowTitle} ${classes.w200}`}
                onChange={(e) => this.onFlowFieldChange('title', e.target.value)}
              />

              <div className={`${classes.w200} ${classes.mr20}`}>
                <TrplSelect
                  margin="none"
                  title="Category"
                  complicatedValues
                  value={flow.category}
                  values={categoryValues}
                  onChange={(e) => this.onFlowCategoryChange(e.target.value)}
                />
              </div>

              {flow.formula ? (
                <div className={`${classes.alignCenter} ${classes.mr20}`}>
                  <div className={classes.mr10}>
                    {flow.formula.cons.map((concept, conceptIndex) => {
                      const sub = categories.find((sub) => sub.id === concept);

                      if (conceptIndex === 0) {
                        return <span key={conceptIndex}>{sub.title} </span>;
                      }

                      return (
                        <span key={conceptIndex}>
                          {' '}
                          {flow.formula.ops[conceptIndex - 1]} {sub.title}
                        </span>
                      );
                    })}
                  </div>

                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={() => this.toggleTargetAudienceModal(true)}
                  >
                    Edit audience
                  </Button>
                </div>
              ) : (
                <Button
                  size="small"
                  color="primary"
                  className={classes.mr20}
                  variant="contained"
                  onClick={() => this.toggleTargetAudienceModal(true)}
                >
                  Set audience
                </Button>
              )}

              <FormControl className={`${classes.w200} ${classes.mr20}`}>
                <InputLabel>Channels</InputLabel>

                <Select
                  multiple
                  disableunderline
                  MenuProps={menuProps}
                  classes={selectClassNames}
                  onChange={(e) => this.onFlowChannelsChange(e.target.value)}
                  value={flow.channels || []}
                >
                  <MenuItem style={itemStyles} value="none">
                    None
                  </MenuItem>

                  {channels.map((channel, channelIndex) => {
                    return (
                      <MenuItem style={itemStyles} key={channelIndex} value={channel.toUpperCase()}>
                        {channel}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <TrplCheckbox
                label="Permanent"
                value={flow.permanent}
                checked={flow.permanent}
                className={classes.mr20}
                onChange={(e) => this.onFlowFieldChange('permanent', e.target.checked)}
              />
              <Button
                size="small"
                variant="contained"
                onClick={() => {
                  const { stimulView } = this.state;

                  stimulView.isOpened = true;
                  stimulView.flow = flow;

                  this.setState({ stimulView });
                }}
              >
                Open stimul view
              </Button>
            </div>

            {flow.stimuls.length ? (
              <div className={`${classes.mt20} ${classes.mb10}`}>
                <span className={`${classes.mb20} ${classes.columnHeadingGeneral}`}>Stimuls:</span>

                {flow.stimuls.map((stimul, stimulIndex) => {
                  return (
                    <Stimul
                      key={stimulIndex}
                      classes={classes}
                      flow={flow}
                      stimul={stimul}
                      stimuls={flow.stimuls}
                      btnsTypes={btnsTypes}
                      stimulIndex={stimulIndex}
                      stimulsTypes={stimulsTypes}
                      onStimulBtnAdd={this.onStimulBtnAdd}
                      onStimulBtnRemove={this.onStimulBtnRemove}
                      onStimulTypeChange={this.onStimulTypeChange}
                      onStimulFieldChange={this.onStimulFieldChange}
                      onStimulCodeFieldClick={this.onStimulCodeFieldClick}
                      onStimulModalPidsChange={this.onStimulModalPidsChange}
                      onStimulBtnInputChange={this.onStimulBtnInputChange}
                      onEditStimulBtnInputChange={this.onEditStimulBtnInputChange}
                      onDeleteStimulClick={() => {
                        this.onDeleteStimulClick(stimulIndex);
                      }}
                    />
                  );
                })}
              </div>
            ) : null}

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Button size="small" color="primary" variant="contained" onClick={() => this.onAddNewStimulClick()}>
                Add new stimul
              </Button>

              <div className={classes.alignCenter}>
                {!flow.isNew ? (
                  <Button variant="contained" color="secondary" size="small" onClick={() => this.openDeleteModal()}>
                    Delete flow
                  </Button>
                ) : null}

                <Button
                  size="small"
                  color="primary"
                  variant="contained"
                  className={classes.ml10}
                  onClick={() => this.onFlowSaveClick(flow)}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(FlowPage);
